"use client"

import { useEffect, useRef } from "react"
import { gsap } from "gsap"
import HomeNavbar from "./HomeNavbar"
import Footer from "./Footer"

const TermsOfService = () => {
  const contentRef = useRef(null)

  useEffect(() => {
    // Content animation
    const contentElement = contentRef.current
    const contentChildren = contentElement?.querySelectorAll(".content-item") || []
    gsap.set(contentChildren, { y: 50, opacity: 0 })

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            gsap.to(contentChildren, {
              y: 0,
              opacity: 1,
              duration: 0.8,
              stagger: 0.2,
              ease: "power3.out",
            })
            observer.unobserve(entry.target)
          }
        })
      },
      { threshold: 0.2 }
    )

    if (contentElement) observer.observe(contentElement)

    return () => {
      if (contentElement) observer.unobserve(contentElement)
    }
  }, [])

  return (
    <div className="min-h-screen bg-slate-900 text-white flex flex-col">
      <HomeNavbar />
      <div className="flex-1 py-10 px-5 md:px-10 lg:px-20">
        <div ref={contentRef} className="max-w-4xl mx-auto bg-slate-700/50 backdrop-blur-sm p-8 rounded-xl">
          <h1 className="content-item text-3xl md:text-4xl font-bold mb-6">Terms of Service</h1>
          <p className="content-item mb-4 text-slate-300">
            Welcome to Algosoftware. By using our platform, you agree to the following terms and conditions.
          </p>
          <h2 className="content-item text-xl md:text-2xl font-semibold mt-6">1. Eligibility</h2>
          <p className="content-item mb-4 text-slate-300">
            You must be at least 18 years old to use our platform. By using Algosoftware, you represent that all information provided is accurate and current.
          </p>
          <h2 className="content-item text-xl md:text-2xl font-semibold mt-6">2. Account Registration</h2>
          <p className="content-item mb-4 text-slate-300">
            Users are required to register for an account and provide accurate information. You are responsible for safeguarding your account credentials and activity under your account.
          </p>
          <h2 className="content-item text-xl md:text-2xl font-semibold mt-6">3. Use of Services</h2>
          <p className="content-item mb-4 text-slate-300">
            Algosoftware is a platform for facilitating algo trading and related financial services. You agree to use the platform in compliance with applicable laws and regulations.
          </p>
          <h2 className="content-item text-xl md:text-2xl font-semibold mt-6">4. Subscription and Fees</h2>
          <p className="content-item mb-4 text-slate-300">
            Certain features require a paid subscription. Details are available on our pricing page.
          </p>
          <h2 className="content-item text-xl md:text-2xl font-semibold mt-6">5. Disclaimer of Liability</h2>
          <p className="content-item mb-4 text-slate-300">
            Algosoftware does not provide financial or investment advice. Trades executed through the platform are your responsibility.
          </p>
          <h2 className="content-item text-xl md:text-2xl font-semibold mt-6">6. Termination</h2>
          <p className="content-item mb-4 text-slate-300">
            We reserve the right to suspend or terminate your account if these Terms are violated.
          </p>
          <h2 className="content-item text-xl md:text-2xl font-semibold mt-6">7. Changes to Terms</h2>
          <p className="content-item mb-4 text-slate-300">
            We may update these Terms periodically. Continued use constitutes acceptance of the changes.
          </p>
          <h2 className="content-item text-xl md:text-2xl font-semibold mt-6">8. Contact Us</h2>
          <p className="content-item mb-4 text-slate-300">
            If you have questions about these Terms, contact us at{" "}
            <b className="text-blue-500">support@algosoftwere.in</b>.
          </p>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default TermsOfService